import { FIELD_MASKING_CONFIG } from "../component/Patient/PatientPotentialSavings/fieldMaskingConfig";
import i18next from "i18next";

/**
 * getMaskedValues(templateName, fieldValues, t)
 *
 * This utility applies masking, fallback, and value overrides to assistance program field data,
 * based on the FIELD_MASKING_CONFIG defined per template (vendor).
 *
 * Key Responsibilities:
 * 1. Hiding fields: Skip fields explicitly marked with `{ show: false }`.
 * 2. Masking values: Use `getValue()` if provided, otherwise fallback to `"--"` if value is undefined.
 * 3. Custom labels: Use `getLabel(t)` if defined, and assign it to `${field}Label`.
 * 4. Propagating non-field-level flags (under `meta`): Useful for controlling layout logic (e.g. `hideSectionX`).
 */
export const getMaskedValues = (templateName, fieldValues, t) => {
  const translationFn = t || i18next.t.bind(i18next);
  const config = FIELD_MASKING_CONFIG[templateName] || {};
  const masked = {};

  Object.entries(fieldValues).forEach(([field, value]) => {
    const fieldConfig = config[field];

    if (fieldConfig?.show === false) return;

    let maskedValue = value;

    if (fieldConfig?.getValue) {
      maskedValue = fieldConfig.getValue(value, translationFn);
    }

    masked[field] = maskedValue !== undefined ? maskedValue : "--";
  });

  Object.entries(config).forEach(([field, fieldConfig]) => {
    if (typeof fieldConfig?.getLabel === "function") {
      masked[`${field}Label`] = fieldConfig.getLabel(translationFn);
    }
  });

  if (config.meta) {
    Object.entries(config.meta).forEach(([metaKey, metaValue]) => {
      masked[metaKey] = metaValue;
    });
  }

  Object.entries(config).forEach(([key, val]) => {
    if (key !== "meta" && typeof val !== "object") {
      masked[key] = val;
    }
  });

  return masked;
};
